import React from "react";
import NodeOfficialTeaser, {
  NodeOfficialTeaserLarge,
} from "components/Official/NodeOfficialTeaser";
import classNames from "lib/classNames";

export default function NodeOfficialList({ nodes }) {
  const officialsByType = [];

  nodes.forEach((node) => {
    const group = node.field_type;

    if (officialsByType[group.drupal_internal__tid] === undefined) {
      officialsByType[group.drupal_internal__tid] = {
        name: group.field_name_plural || group.name,
        weight: group.weight,
        nodes: [],
      };
    }

    officialsByType[group.drupal_internal__tid].nodes.push(node);
  });

  const sortedOfficialsByType = officialsByType.sort(
    (a, b) => Number(a.weight) - Number(b.weight)
  );

  return sortedOfficialsByType.map((group, index) => {
    const isFirst = index === 0;
    return (
      <div className={isFirst ? "" : "mt-12"} key={group.weight}>
        <h2
          className={classNames(
            isFirst ? "sr-only" : "mb-8 font-important font-bold text-xl"
          )}
        >
          {group.name}
        </h2>
        {isFirst ? (
          <NodeOfficialTeaserLarge node={group.nodes[index]} />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {group.nodes.map((node) => (
              <div key={node.id}>
                <NodeOfficialTeaser node={node} />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  });
}
